/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class PublishField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const options = [
      { key: 1, text: 'Draft', value: 'draft' },
      { key: 2, text: 'Publish', value: 'publish' },
    ]

    return (
      <Form.Select
        required
        fluid
        label="Status"
        options={options}
        placeholder="Publish/Draft"
        onChange={(e, data) => onChange('status', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/publishField.js